import { Component, Input } from '@angular/core';
import { IModulesList } from 'src/app/interfaces/imodules-list';
import { ReportingService } from 'src/app/services/reporting/reporting.service';
import { Router } from '@angular/router';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { TranslocoService } from '@jsverse/transloco';
import { TranslationService } from 'src/app/services/translation.service';


@Component({
  selector: 'app-modules-list',
  templateUrl: './modules-list.component.html',
  styleUrls: ['./modules-list.component.scss'],
  standalone: false
})
export class ModulesListComponent {
  @Input() accountUuid: string = '';
  modulesList: IModulesList[] = [];
  isModulesLoading: boolean = true;
  showAllModules: boolean = false;
  ctaImg = "/assets/icons/arrow/chevron-down-dark-blue.svg";
  remainingModules: number = 0;
  toggleString: string = '';

  constructor(
    private reportingService: ReportingService,
    private router: Router,
    private amplitudeService: AmplitudeService,
    private translocoService: TranslocoService,
    private translationService: TranslationService
  ) {}

  ngOnInit() {
    this.translationService.loadScopedTranslation('reporting').then(() => {
      this.getModulesList();
    })

  }

  getModulesList() {
    this.reportingService.getModulesList(this.accountUuid).subscribe({
      next: (res: IModulesList[]) => {
        this.isModulesLoading = false;
        this.modulesList = res;
        this.remainingModules = this.modulesList.length > 4 ? this.modulesList.length - 4 : 0;
        this.toggleString = `${this.translocoService.translate('SEE_ALL', {}, 'reporting')}(${this.remainingModules})`;
      },
      error: (error) => {
        this.isModulesLoading = false;
        console.error('Error fetching modules list', error);
      }
    });
  }

  toggleOldModules() {
    this.showAllModules = !this.showAllModules;
    if (!this.showAllModules) {
      this.toggleString = `${this.translocoService.translate('SEE_ALL', {}, 'reporting')}(${this.remainingModules})`;
      this.ctaImg = "assets/icons/arrow/chevron-down-dark-blue.svg";
    } else {
      this.toggleString = this.translocoService.translate('SEE_LESS', {}, 'reporting');
      this.ctaImg = "/assets/icons/arrow/chevron-up-dark-blue.svg";
    }
  }

  navigateToRoute(module: IModulesList) {
    // Sending the Clicked Module Name and UUID from Module Card to Amplitude
    this.amplitudeService.trackEvent('rollupreport_click_modulecard', {
      'module_name': module.moduleName,
      'module_uuid': module.moduleUuid,
    });
    const returnUrl = `/reporting_visualization?moduleUuid=${module.moduleUuid}`;
    localStorage.setItem('returnUrl', encodeURIComponent(returnUrl));

    this.router.navigate(['/reporting_visualization'], { queryParams: { moduleUuid: module.moduleUuid } });
  }
}
